import type { Dictionary } from 'types';
import type { VariantAttribute } from 'types/variant';

import type { MarketConfiguration } from '@/config/markets/const';
import { getGooglePriceForVariant } from '@/utils/googlePricing';
import { formatPrice } from '@/utils/priceUtils';

/** @deprecated */
export default function showPrice({
    variantAttributes,
    dictionary,
    market,
}: {
    variantAttributes: VariantAttribute[];
    dictionary: Dictionary;
    market: MarketConfiguration;
}) {
    if (!variantAttributes?.length) return '-';

    const prices = variantAttributes.map((attribute) => {
        const googlePrice = getGooglePriceForVariant(market, attribute.id);
        return {
            price: googlePrice ?? attribute.price.price,
            originalPrice: attribute.price.originalPrice,
            priceType: attribute.price.priceType,
        };
    });

    const sortedPrices = prices.sort((a, b) => a.price - b.price);
    const min = sortedPrices.at(0);
    const max = sortedPrices.at(-1);

    if (!min || !max) return '-';

    return (
        <div className="flex flex-col-reverse">
            <span>
                {min.price < max.price && (
                    <>
                        {dictionary?.fromShortened}
                        &nbsp;
                    </>
                )}
                <span className="font-medium">
                    {formatPrice(min.price, market.locale)}
                </span>
            </span>
            {min.priceType === 'campaign' && (
                <span className="ml-2 text-xs text-grey-300 line-through">
                    {formatPrice(min.originalPrice ?? 0, market.locale)}
                </span>
            )}
        </div>
    );
}
